import { AutoPlanComponent } from './auto-plan.component';
import { AutoPlanOperationsComponent } from './auto-plan-operations/auto-plan-operations.component';
import { AutoPlanDownloadsComponent } from './downloads/auto-plan-downloads.component';
var components = [
    AutoPlanComponent,
    AutoPlanOperationsComponent,
    AutoPlanDownloadsComponent
];
var AutoPlanModule = /** @class */ (function () {
    function AutoPlanModule() {
    }
    return AutoPlanModule;
}());
export { AutoPlanModule };
